// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { any, boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const colorProfileValidationObject = objectOf({
  color_profile_id: string,
  color_profile_name: maybe(string, true),
  color_profile_description: maybe(string, true),
  profile_type: number,
  tag_names: arrayOf(string),
  territory_ids: arrayOf(string),
  marked_as_deleted: boolean,
  last_edited_at: maybe(number, true),
  created_by: maybe(string, true),
  last_edited_by: maybe(string, true),
  buttons: maybe(
    arrayOf(
      objectOf({
        background_color: maybe(number, true),
        text_color: maybe(number, true),
        border_color: maybe(number, true),
      })
    )
  ),
  close_button_color: maybe(number, true),
  background_color: maybe(number, true),
  body_text_color: maybe(number, true),
  header_text_color: maybe(number, true),
  frame_color: maybe(number, true),
  icon_color: maybe(number, true),
  icon_background_color: maybe(number, true),
  custom_css: maybe(string, true),
  default: maybe(boolean, true),
  grapes_js_data: maybe(any, true),
  dnd_display_type: maybe(string, true),
});

export const isEngagementInAppMessageColorProfilesIdResult = colorProfileValidationObject;
